import platform from '../utils/platform';
import { isProduction } from '../utils/environment';

let DSN =
  platform === 'native'
    ? 'https://8d07c24f1b4746e6b5182b4ec0286120@sentry.io/275600'
    : 'https://cf72eadfdce34e13a3e54618de4817f9@sentry.io/275595';
DSN = !isProduction() ? false : DSN;

export default {
  DSN,
};
